module.exports = __webpack_public_path__ + "static/willbud-puck-tablet-844a0332bc8152c7e34c7ea64ff6ffdb.jpg";